import styles from "./DataTableSkeleton.module.scss";

type Props = {
  columnsCount: number;
  rowsCount: number;
};

const DataTableSkeleton: React.FC<Props> = ({ columnsCount, rowsCount }) => {
  const getSkeletonCols = (cols: number) => {
    if (cols <= 8) return 6;
    if (cols <= 14) return 10;
    return 16;
  };

  const getSkeletonRows = (rows: number) => {
    if (rows >= 12) return 100;
    return 6;
  };

  const cols = getSkeletonCols(columnsCount);
  const rows = getSkeletonRows(rowsCount);

  const rowsArray = Array.from({ length: rows });
  const colsArray = Array.from({ length: cols });

  const getCellClass = (index: number) => {
    if (index < 2) return styles.skeletonCellSmall;
    return styles.skeletonCell;
  };

  return (
    <div className="game-table-wrap table">
      <table className="game-table">
        <thead className={styles.skeletonHead}>
          <tr>
            {colsArray.map((_, index) => (
              <th
                key={index}
                className={
                  index === 0
                    ? styles.checkboxCol
                    : index === 1
                      ? styles.idCol
                      : ""
                }
              >
                <div className={`${getCellClass(index)} skeleton`} />
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rowsArray.map((_, rowIndex) => (
            <tr key={rowIndex}>
              {colsArray.map((_, colIndex) => (
                <td key={colIndex}>
                  <div className={`${getCellClass(colIndex)} skeleton`} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableSkeleton;